<template>
    <div>
        <v-container ma-0 pa-0 px-4 class="container-with-horizontal-scroll" fluid>
                <v-row style="flex-wrap: nowrap">
                    <v-col cols="10" xs="8" sm="6" md="3" class="pa-1 ma-0"
                           v-for="jumpType in jumpTypes"
                           :key="jumpType.type"
                    >
                        <v-card class="blue-grey lighten-5 d-flex flex-column" height="100%">
                            <v-card-title class="ml-2 pa-1">
                                <v-list-item-title class="bold subtitle-1">
                                    {{jumpType.title}}
                                </v-list-item-title>
                            </v-card-title>
                            <div v-bind:style="[{height: (windowHeight - (jumpTypes.length > 4 ? 230 : 170)) + 'px'},{display: 'flex'},{'flex-direction': 'column'}]">
                                <div class="content">
                                    <v-card-text class="pa-0 ma-0"
                                                 v-for="(jump, index) in jumps"
                                                 :key="jump.id"
                                    >
                                        <jump-card
                                            :model="jump"
                                            :index="index + 1"
                                            @editModel="editModel(index)"
                                            @removeModel="removeModel(index)"
                                            v-if="jumpType.type === jump.type"
                                        ></jump-card>
                                    </v-card-text>
                                </div>
                            </div>
                            <v-card-actions class="ma-0 pa-0">
                                <v-btn
                                       class="caption"
                                       block
                                       color="primary"
                                       text
                                       dark
                                       @click="createJump"
                                       v-if="jumpType.buttonCreate"
                                >Создать переход</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
        </v-container>
        <jump-form
                :index="editModelIndex"
                :dialog="dialog"
                @close="dialog = false"
        ></jump-form>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogConfirmation from '../../components/dialogs/DialogConfirmation'
import JumpForm from '../../components/bot/jump/JumpForm'
import JumpCard from '../../components/bot/jump/JumpCard'
export default {
    name: 'Jump',
    components: {
        DialogConfirmation,
        JumpForm,
        JumpCard
    },
    data() {
        return {
            jumpTypes: [
                {
                    title: 'Пользовательские',
                    type: 0,
                    buttonCreate: true
                },
                {
                    title: 'Сценарии',
                    type: 1,
                    buttonCreate: false
                },
                {
                    title: 'Рассылки',
                    type: 2,
                    buttonCreate: false
                },
                {
                    title: 'События',
                    type: 3,
                    buttonCreate: false
                }
            ],
            dialog: false,
            editModelIndex: null,
            dialogParams: {},
            indexEdit: null,
            windowHeight: 0
        }
    },
    methods: {
        editModel(index) {
            this.editModelIndex = index
            this.dialog = true
        },
        async removeModel(index) {
            this.$refs.confirm.open('Удаление сообщения', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('messages/removeMessage', index)
                    }
                })
        },
        createJump() {
            this.dialog = true
        },
        handleResize() {
            this.windowHeight = window.innerHeight
        }
    },
    created() {
        let botId = this.$route.params['pathMatch']
        this.$store.dispatch('jumps/loadJumps', botId)
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    watch: {
        dialog(value) {
            if (value === false) { this.editModelIndex = null }
        }
    },
    computed: {
        ...mapGetters({
            jumps: 'jumps/jumps'
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
</style>
